import React, { forwardRef } from 'react'

import i18n from '../../locales/i18n'
import PuiTextField from '../inputs/PuiTextField'
import BaseSignature, {
  BaseSignatureHandle,
  BaseSignatureProps,
} from './BaseSignature'

const FreeNameSignature = forwardRef<BaseSignatureHandle, BaseSignatureProps>(
  function FreeNameSignature(props, ref) {
    return (
      <BaseSignature ref={ref} {...props}>
        {({ field }) => (
          <PuiTextField
            field={field}
            label={i18n.t<string>(
              'Common:SIGNATURE.PLEASE_TYPE_YOUR_NAME_HERE',
            )}
          />
        )}
      </BaseSignature>
    )
  },
)

export default FreeNameSignature
